import React from "react";
import {
  Box,
  Button,
  Popover,
  IconButton,
  MenuList,
  MenuItem,
  ListItemText
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import PopupState, {
  bindTrigger,
  bindPopover,
} from "material-ui-popup-state";
import moment from "moment";

const InfoDateUpdate = ({ contractId, lastUpdate, onUpdate, onExport }) => {
  const classes = useStyles();

  const handleExport = (type, popupState) => {
    popupState.close();
    onExport(type);
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.left}>
        <Box className={classes.titleRow}>
          <h1 className={classes.title}>Главная</h1>
          <span className={classes.dateText}>Актуально на {moment(lastUpdate).format('DD.MM.YYYY HH:mm:ss')}</span>
          <IconButton className={classes.refreshBtn} onClick={onUpdate} size="small">
            <img src={require('../../../../assets/svg/home/refresh-badge.svg').default} width={40} height={40} alt="" />
          </IconButton>
        </Box>
      </Box>
      <Box>
        <PopupState variant="popover">
          {(popupState) => (
            <div>
              <Button
                variant="outlined"
                className={classes.exportBtn}
                startIcon={
                  <img src={require('../../../../assets/svg/home/cloud-download.svg').default} width={20} height={20} alt="" />
                }
                {...bindTrigger(popupState)}
              >
                Экспорт отчета
              </Button>
              <Popover
                {...bindPopover(popupState)}
                anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                transformOrigin={{vertical: 'top', horizontal: 'right'}}
              >
                <MenuList>
                  <MenuItem onClick={handleExport.bind(this, '0', popupState)}>
                    <ListItemText>UTF-8 (По умолчанию)</ListItemText>
                  </MenuItem>
                  <MenuItem onClick={handleExport.bind(this, '10', popupState)}>
                    <ListItemText>Windows-1251</ListItemText>
                  </MenuItem>
                </MenuList>
              </Popover>
            </div>
          )}
        </PopupState>
      </Box>
    </Box>
  )
}

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  left: {
    display: "flex",
    alignItems: "center",
    gap: 20,
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    gap: 20,
  },
  title: {
    margin: 0,
    fontSize: 24,
    fontWeight: 500,
    lineHeight: "28px",
    color: "#111111",
  },
  dateText: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: "20px",
    color: "#71717A",
  },
  refreshBtn: {
    padding: "0 !important",
    width: 40,
    height: 40,
  },
  exportBtn: {
    borderColor: "#E4E4E7",
    color: "#27272A",
    fontSize: 14,
    fontWeight: 500,
    lineHeight: "20px",
    height: 40,
    padding: "0 16px",
    borderRadius: 4,
    textTransform: "none",
    "&:hover": {
      borderColor: "#4F39F6",
      color: "#4F39F6",
      backgroundColor: "transparent",
    },
  },
}));

export default InfoDateUpdate
